import React from "react";
import { useTranslation } from "react-i18next";
import { NavLink as RRNavLink } from "react-router-dom";
import { NavItem, NavLink } from "reactstrap";

const SettingMenu = () => {
  const { t } = useTranslation();
  return (
    <div className="card settings_menu">
      <div className="card-header">
        <h4 className="card-title">{t("settings.label")}</h4>
      </div>
      <div className="card-body">
        <ul>
          <NavItem>
            <NavLink to="/settings" exact tag={RRNavLink}>
              <i className="la la-user"></i>
              <span>{t("edit.profile.label")}</span>
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink to="/settingsPreferences" tag={RRNavLink}>
              <i className="la la-cog"></i>
              <span>{t("preferences.label")}</span>
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink to="/settingsSecurity" tag={RRNavLink}>
              <i className="la la-lock"></i>
              <span>{t("security.label")}</span>
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink to="/settingsAccount" tag={RRNavLink}>
              <i className="la la-bank"></i>
              <span>{t("bank.info.label")}</span>
            </NavLink>
          </NavItem>
        </ul>
      </div>
    </div>
  );
};

export default SettingMenu;
